/* The theme's generic smooth-scroll handler does not transfer focus.
   Only this guide's explicit glossary links are enhanced. */
(function(){
  'use strict';
  var guide=document.querySelector('.oh-rx-guide');
  if(!guide)return;
  guide.addEventListener('click',function(event){
    var link=event.target.closest('a[href^="#rx-"]');
    if(!link||!guide.contains(link)||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    var target=document.getElementById(link.hash.slice(1));
    if(!target||!guide.contains(target))return;
    event.preventDefault();event.stopPropagation();
    target.setAttribute('tabindex','-1');
    target.focus({preventScroll:true});
    history.replaceState(history.state,'',link.hash);
    target.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  });
})();
